import prudentialUpImg from "assets/images/prudential-up.png";
import searchImg from "assets/images/Search.png";
import { AvField, AvForm } from "availity-reactstrap-validation";
import PropTypes from "prop-types";
import React, { useCallback, useEffect, useState } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import MetaTags from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import {
  getSearchResult,
  resetDownloadType,
  searchCodePortal,
} from "store/portal/actions";
import ResultSearch from "./SearchResult";
import { env } from "configs/EnvironmentConfig";

const Login = props => {
  const dispatch = useDispatch();
  const [detailModal, setDetailModal] = useState(false);
  const [valueParamUrl, setValueParamsUrl] = useState("");
  const [urlPDF, setUrlPDF] = useState("");
  const { addToast } = useToasts();
  const Portal = useSelector(state => state.Portal);
  const {
    loading,
    capcha,
    errorSearch,
    dataVerity,
    dataSearch,
    errorDownload,
    errorSearchResult,
    statusFailSearch,
  } = Portal;

  const toggleDetailModal = (modeSet = "") => {
    setDetailModal(!detailModal);
  };

  const base64toBlob = data => {
    if (Object.keys(data).length > 0) {
      const base64WithoutPrefix = data.substr(
        "data:application/pdf;base64,".length
      );
      const bytes = atob(base64WithoutPrefix);
      let length = bytes.length;
      let out = new Uint8Array(length);

      while (length--) {
        out[length] = bytes.charCodeAt(length);
      }

      return new Blob([out], { type: "application/pdf" });
    }
  };

  useEffect(() => {
    if (
      dataSearch &&
      dataSearch.data &&
      Object.keys(dataSearch.data).length > 0
    ) {
      const blob = base64toBlob(dataSearch.data);
      const url = URL.createObjectURL(blob);
      setUrlPDF(url);
    } else{
      setUrlPDF(null);
    }
  }, [dataSearch]);

  useEffect(() => {
    if (errorDownload) {
      addToast("Tải tệp không thành công, vui lòng thử lại", {
        appearance: "error",
        autoDismiss: true,
      });
      dispatch(resetDownloadType());
    }
  }, [errorDownload]);

  useEffect(() => {
    var invoice_code = new URLSearchParams(window.location.search).get(
      "invoice_code"
    );
    if (invoice_code) {
      setValueParamsUrl(invoice_code);
    }
  }, []);

  const fakeData = {
    status: true,
    token: "ASNDBHfajwhfajkwbgjhgbawASDKVA",
    model: [
      {
        id: 832,
        filename: "abc.pdf",
      },
      {
        id: 2,
        filename: "xyz.pdf",
      },
    ],
  };

  useEffect(() => {
    if (errorSearchResult) {
      addToast("Không tìm thấy tệp tin", {
        appearance: "error",
        autoDismiss: true,
      });
      dispatch(resetDownloadType());
    }
  }, [errorSearchResult]);

  useEffect(() => {
    if (dataVerity && dataVerity.model && dataVerity.model.length > 0) {
      toggleDetailModal();
      dispatch(
        getSearchResult({
          id: dataVerity.model[0].id,
          token: dataVerity.token,
        })
      );
    } else {
      if (errorSearch) {
        // Token
        let errorCaptcha = errorSearch?.errors?.tokenRecaptchaV3;
        if (errorCaptcha) {
          for (const item of errorCaptcha) {
            let messageError = null;
            switch (item) {
              case "invalid-input-response":
                messageError = "Captcha không hợp lệ";
                break;
              case "score-threshold-not-met":
                messageError = "Captcha không hợp lệ";
                break;
              case "hostname-mismatch":
                messageError = "Domain không hợp lệ";
                break;
              default:
                break;
            }
            if (messageError) {
              addToast(messageError, {
                appearance: "error",
                autoDismiss: true,
              });
            }
          }
        }

        // Mã tra cứu
        let errorInvoiceCode = null;
        if (errorSearch?.errors?.invoice_code) {
          errorInvoiceCode = "Mã tra cứu không tồn tại";
        }
        if (errorInvoiceCode) {
          addToast(errorInvoiceCode, {
            appearance: "error",
            autoDismiss: true,
          });
        }
      }
    }
  }, [dataVerity, errorSearch]);

  const handleCloseModel = () => {
    toggleDetailModal();
  };

  const { executeRecaptcha } = useGoogleReCaptcha();
  const [tokenRecaptcha, setTokenRecaptcha] = useState(null);

  // Create an event handler so you can call the verification on button click event or form submit
  const handleReCaptchaVerify = useCallback(
    async values => {
      if(env.API_ENABLE_CAPTCHA === "ENABLE"){
        if (!executeRecaptcha) {
          addToast("Execute recaptcha not yet available", {
            appearance: "error",
            autoDismiss: true,
          });
          return;
        }
        const tokenRecaptchaV3 = await executeRecaptcha("searchInvoiceCode");
        if (tokenRecaptchaV3) {
          setUrlPDF(null)
          dispatch(searchCodePortal({ ...values, tokenRecaptchaV3 }));
        } else {
          addToast("Captcha lỗi", {
            appearance: "error",
            autoDismiss: true,
          });
        }
      }else{
        setUrlPDF(null)
        dispatch(searchCodePortal({ ...values, tokenRecaptchaV3:"DISABLE_RECAPTCHA_V3" }));
      }
     
    },
    [executeRecaptcha]
  );

  // You can use useEffect to trigger the verification as soon as the component being loaded
  //   useEffect(() => {
  //     handleReCaptchaVerify();
  //   }, [handleReCaptchaVerify]);

  return (
    <React.Fragment>
      <MetaTags>
        <title>Tra cứu hóa đơn | Tổ chức giải pháp</title>
      </MetaTags>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="fas fa-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <ResultSearch
            dataSearch={dataSearch}
            isOpenModal={detailModal}
            toggleModal={toggleDetailModal}
            pdf={urlPDF}
            dataVerity={dataVerity}
            handleCloseModel={handleCloseModel}
          />
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card
                className="overflow-hidden"
                style={{
                  borderRadius: "10px 10px 10px 10px",
                }}
              >
                <div className="bg-soft" style={{ background: "#ED1B2E" }}>
                  <Row>
                    <Col xs={8}>
                      <div className="text-primary p-4">
                        <img src={prudentialUpImg} alt="" height="34" />
                        <h3 style={{ color: "white", marginTop: "17px" }}>
                          CHÀO MỪNG BẠN!
                        </h3>
                      </div>
                    </Col>
                    <Col className="col-4 d-flex align-items-center justify-content-between">
                      <img src={searchImg} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <div
                      className="avatar-md profile-user-wid mb-2"
                      style={{
                        marginLeft: "20px",
                      }}
                    ></div>
                  </div>
                  <span
                    className="h3"
                    style={{
                      marginLeft: "8px",
                      borderBottom: "3px solid #ED1B2E",
                    }}
                  >
                    Tra cứu hóa đơn
                  </span>
                  <div className="p-2 mt-3">
                    <AvForm
                      className="form-horizontal"
                      onValidSubmit={(e, v) => {
                        handleReCaptchaVerify(v);
                      }}
                    >
                      <div className="mb-3">
                        <AvField
                          name="invoice_code"
                          id="invoice_code"
                          label="Mã số tra cứu"
                          className="form-control"
                          type="text"
                          validate={{
                            required: {
                              value: true,
                              errorMessage: "Vui lòng nhập Mã số tra cứu",
                            },
                          }}
                          value={valueParamUrl}
                          placeholder="Nhập Mã số tra cứu"
                        />
                      </div>
                      <div className="mt-3 d-grid justify-content-center">
                        <button
                          className="btn  btn-block d-flex justify-content-center align-items-center"
                          type="submit"
                          disabled={loading}
                          style={{
                            width: "109px",
                            borderRadius: "7px",
                            background: "#ED1B2E",
                            color: "white",
                          }}
                          //   onClick={handleReCaptchaVerify}
                        >
                          {loading && (
                            <div
                              className="spinner-border spinner-border-sm mx-2"
                              role="status"
                            >
                              <span className="sr-only">Loading...</span>
                            </div>
                          )}
                          <span> Tra cứu</span>
                        </button>
                      </div>
                    </AvForm>
                  </div>
                </CardBody>
              </Card>
              {/* <div className="mt-4 font-size-18 text-center text-danger">
                <p>
                  4Si E-Invoice © {new Date().getFullYear()} - Hotline: 19001837
                </p>
              </div> */}
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Login);

Login.propTypes = {
  history: PropTypes.object,
};
